"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gridContext = require("./grid-context");

var _core = require("@emotion/core");

var _grid = _interopRequireDefault(require("./grid"));

var _spacing = _interopRequireDefault(require("./spacing"));

var _mixins = require("../mixins");

var _colors = require("../colors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n      ", "\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var styledCol = function styledCol(props, targetColumns) {
  var layout = props.layout,
      column = props.column;
  var firstCol = column === 1;
  var space = targetColumns === 1 ? _spacing["default"].Close : _spacing["default"].Large;

  if (layout === 2 && targetColumns === 2) {
    return "margin: ".concat(firstCol ? "0 0 0 ".concat(space) : "0 ".concat(space, " 0 0"), ";");
  }

  return "margin: 0 ".concat(space, ";");
};

var StyledContainer = (0, _styledBase["default"])("section", {
  target: "e1k0wlvm0",
  label: "StyledContainer"
})(function (props) {
  var fullBleed = props.fullBleed,
      withPadding = props.withPadding;
  return (
    /*#__PURE__*/
    (0, _core.css)(_grid["default"].grid, " ", _grid["default"].close, " ", fullBleed ? "\n      margin: 0;\n      background-color: ".concat(props.color, ";\n      padding: ").concat(withPadding ? _spacing["default"].Close : 0, ";\n      ") : styledCol(props, 1), " ", _mixins.breakpoint.md(_templateObject(), fullBleed ? "\n        padding: ".concat(withPadding ? _spacing["default"].Close : 0, " ").concat(withPadding ? _spacing["default"].Large : 0, ";\n      ") : styledCol(props, 2)), " @media only screen and (-ms-high-contrast:none){flex-direction:column;margin-bottom:", _spacing["default"].Separate, ";> div:last-child{margin-bottom:0;}}> p{margin:0;}label:StyledContainer;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9MYXlvdXQvQ29udGFpbmVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTJCYSIsImZpbGUiOiIuLi8uLi9zcmMvTGF5b3V0L0NvbnRhaW5lci5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBMYXlvdXRDb250ZXh0LCBDb2xDb250ZXh0IH0gZnJvbSAnLi9ncmlkLWNvbnRleHQnO1xuaW1wb3J0IHsganN4LCBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBHcmlkIGZyb20gJy4vZ3JpZCc7XG5pbXBvcnQgU3BhY2luZyBmcm9tICcuL3NwYWNpbmcnO1xuaW1wb3J0IHsgYnJlYWtwb2ludCB9IGZyb20gJy4uL21peGlucyc7XG5pbXBvcnQgeyBncmF5IH0gZnJvbSAnLi4vY29sb3JzJztcblxuY29uc3Qgc3R5bGVkQ29sID0gKHByb3BzLCB0YXJnZXRDb2x1bW5zKSA9PiB7XG4gIGNvbnN0IHsgbGF5b3V0LCBjb2x1bW4gfSA9IHByb3BzO1xuICBjb25zdCBmaXJzdENvbCA9IGNvbHVtbiA9PT0gMTtcblxuICBjb25zdCBzcGFjZSA9IHRhcmdldENvbHVtbnMgPT09IDEgPyBTcGFjaW5nLkNsb3NlIDogU3BhY2luZy5MYXJnZTtcblxuICBpZiAobGF5b3V0ID09PSAyICYmIHRhcmdldENvbHVtbnMgPT09IDIpIHtcbiAgICByZXR1cm4gYG1hcmdpbjogJHtmaXJzdENvbCA/IGAwIDAgMCAke3NwYWNlfWAgOiBgMCAke3NwYWNlfSAwIDBgfTtgO1xuICB9XG5cbiAgcmV0dXJuIGBtYXJnaW46IDAgJHtzcGFjZX07YDtcbn07XG5cbmNvbnN0IFN0eWxlZENvbnRhaW5lciA9IHN0eWxlZC5zZWN0aW9uKChwcm9wcykgPT4ge1xuICBjb25zdCB7IGZ1bGxCbGVlZCwgd2l0aFBhZGRpbmcgfSA9IHByb3BzO1xuXG4gIHJldHVybiAoY3NzYFxuICAgICR7R3JpZC5ncmlkfVxuICAgICR7R3JpZC5jbG9zZX1cblxuICAgICR7ZnVsbEJsZWVkID8gYFxuICAgICAgbWFyZ2luOiAwO1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHtwcm9wcy5jb2xvcn07XG4gICAgICBwYWRkaW5nOiAke3dpdGhQYWRkaW5nID8gU3BhY2luZy5DbG9zZSA6IDB9O1xuICAgICAgYCA6IHN0eWxlZENvbChwcm9wcywgMSl9XG5cbiAgICAke2JyZWFrcG9pbnQubWRgXG4gICAgICAke2Z1bGxCbGVlZCA/IGBcbiAgICAgICAgcGFkZGluZzogJHt3aXRoUGFkZGluZyA/IFNwYWNpbmcuQ2xvc2UgOiAwfSAke3dpdGhQYWRkaW5nID8gU3BhY2luZy5MYXJnZSA6IDB9O1xuICAgICAgYCA6IHN0eWxlZENvbChwcm9wcywgMil9XG4gICAgYH1cblxuICAgIEBtZWRpYSBvbmx5IHNjcmVlbiBhbmQgKC1tcy1oaWdoLWNvbnRyYXN0OiBub25lKSB7XG4gICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgbWFyZ2luLWJvdHRvbTogJHtTcGFjaW5nLlNlcGFyYXRlfTtcblxuICAgICAgPiBkaXY6bGFzdC1jaGlsZCB7XG4gICAgICAgIG1hcmdpbi1ib3R0b206IDA7XG4gICAgICB9XG4gICAgfVxuXG4gICAgPiBwIHtcbiAgICAgIG1hcmdpbjogMDtcbiAgICB9XG4gIGApO1xufSk7XG5cbi8qKiAvLyBDb250YWluZXIgQ29tcG9uZW50XG4gKiBpbXBvcnQgeyBMYXlvdXQgfSBmcm9tICdAa2JiY29tcG9uZW50bGlicmFyeS9wcmluY2lwbGVzJztcbiAqIGNvbnN0IHsgU2VjdGlvbiB9ID0gTGF5b3V0O1xuICogKi9cblxuY29uc3QgQ29udGFpbmVyID0gcHJvcHMgPT4gKFxuICA8TGF5b3V0Q29udGV4dC5Db25zdW1lcj5cbiAgICB7bGF5b3V0ID0+IChcbiAgICAgIDxDb2xDb250ZXh0LkNvbnN1bWVyPlxuICAgICAgICB7Y29sdW1uID0+IChcbiAgICAgICAgICA8U3R5bGVkQ29udGFpbmVyIGxheW91dD17bGF5b3V0fSBjb2x1bW49e2NvbHVtbn0gey4uLnByb3BzfSAvPlxuICAgICAgICApfVxuICAgICAgPC9Db2xDb250ZXh0LkNvbnN1bWVyPlxuICAgICl9XG4gIDwvTGF5b3V0Q29udGV4dC5Db25zdW1lcj5cbik7XG5cbkNvbnRhaW5lci5kaXNwbGF5TmFtZSA9ICdDb250YWluZXInO1xuXG5Db250YWluZXIucHJvcFR5cGVzID0ge1xuICBjaGlsZHJlbjogUHJvcFR5cGVzLm5vZGUsXG4gIGZ1bGxCbGVlZDogUHJvcFR5cGVzLmJvb2wsXG4gIGNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuQ29udGFpbmVyLmRlZmF1bHRQcm9wcyA9IHtcbiAgd2l0aFBhZGRpbmc6IHRydWUsXG4gIGZ1bGxCbGVlZDogZmFsc2UsXG4gIGNvbG9yOiBncmF5LmxpZ2h0NDAsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBDb250YWluZXI7XG4iXX0= */"))
  );
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
/** // Container Component
 * import { Layout } from '@kbbcomponentlibrary/principles';
 * const { Section } = Layout;
 * */

var Container = function Container(props) {
  return (0, _core.jsx)(_gridContext.LayoutContext.Consumer, null, function (layout) {
    return (0, _core.jsx)(_gridContext.ColContext.Consumer, null, function (column) {
      return (0, _core.jsx)(StyledContainer, (0, _extends2["default"])({
        layout: layout,
        column: column
      }, props));
    });
  });
};

Container.displayName = 'Container';
Container.propTypes = {
  children: _propTypes["default"].node,
  fullBleed: _propTypes["default"].bool,
  color: _propTypes["default"].string
};
Container.defaultProps = {
  withPadding: true,
  fullBleed: false,
  color: _colors.gray.light40
};
var _default = Container;
exports["default"] = _default;
Container.__docgenInfo = {
  "description": "// Container Component\nimport { Layout } from '@kbbcomponentlibrary/principles';\nconst { Section } = Layout;",
  "methods": [],
  "displayName": "Container",
  "props": {
    "withPadding": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false
    },
    "fullBleed": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "color": {
      "defaultValue": {
        "value": "gray.light40",
        "computed": true
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Layout/Container.js"] = {
    name: "Container",
    docgenInfo: Container.__docgenInfo,
    path: "src/Layout/Container.js"
  };
}